import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { deadline: String, template: String, expired: String }

  connect() {
    this.deadline = Date.parse(this.deadlineValue)
    if (Number.isNaN(this.deadline)) return

    this.render()
    this.timer = setInterval(() => this.render(), 30000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  render() {
    const minutes = Math.ceil((this.deadline - Date.now()) / 60000)
    if (minutes <= 0) {
      this.element.textContent = this.expiredValue
      this.element.closest("[data-awaiting]")?.setAttribute("data-expired", "true")
      clearInterval(this.timer)
      return
    }

    this.element.textContent = this.templateValue.replace("%{left}", this.format(minutes))
  }

  format(minutes) {
    if (minutes < 60) return `${minutes} min`
    return `${Math.floor(minutes / 60)} h ${String(minutes % 60).padStart(2, "0")} min`
  }
}
